module.exports = __webpack_public_path__ + "static/media/Public_31.c6926b24.jpg";